export default __webpack_public_path__ + "static/media/animation-2.6304282d.gif";